<style lang="less">
.confirm {
	width: 35% !important;

	p {
		overflow: initial;
		white-space: initial !important;
	}
}
</style>
<style scoped lang="less">
/deep/ .el-message-box {
	width: 70% !important;
}

.el-message-box__message p {
	white-space: initial !important;
}

/deep/ .el-empty {
	background-color: #fff;
	margin: 1rem 0;
}

.elpagian {
	display: flex;
	align-items: center;
	justify-content: center;

	.el-pagination {
		border: 1px solid transparent;
		padding: 0.4rem 1rem;
		border-radius: 4rem;
		background-color: #fff;
		box-shadow: 0 0px 10px 0;
	}
}

.contentbox {
	width: 100%;

	ul {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		justify-content: space-between;

		@media (min-width: 992px) {
			.col-lg-3 {
				-webkit-box-flex: 0;
				-ms-flex: 0 0 auto;
				flex: 0 0 auto;
				width: 19% !important;
			}

			li:last-child:nth-child(5n + 2) {
				// background-color: orangered;
				margin-right: calc((100% - 19%) / 4 * 3);
			}

			li:last-child:nth-child(5n + 3) {
				// background-color: hotpink;
				margin-right: calc((100% - 18%) / 4 * 2);
			}

			li:last-child:nth-child(5n + 4) {
				// background-color: blueviolet;
				margin-right: calc((100% - 18%) / 4 * 1);
			}
		}

		li {
			box-sizing: border-box;
			background: #fff;
			border-radius: 2px;
			margin: 1rem 0;
			position: relative;
			margin: 1rem 0;
			box-shadow: 2px 6px 10px 0;
			overflow: hidden;

			img {
				width: 100%;
				height: 16rem;
				object-fit: cover;
				transition: 0.8s;
			}

			img:hover {
				transform: scale(1.1);
			}

			.titimes {
				font-size: 0.8rem;
				color: #333;
				margin: 1rem 0 0.5rem 0.5rem;
				font-weight: 700;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.contenbz {
				color: rgb(132, 137, 140);
				margin-left: 10px;
				font-size: 0.8rem;
				margin-bottom: 0.6rem;
			}

			.more,
			.delete {
				width: 97%;
				background-color: #0acf97;
				color: #fff;
				font-size: 1rem;
				display: block;
				padding: 0.8rem 0;
				border-radius: 5px;
				margin: 1rem auto;
				box-sizing: border-box;
				text-align: center;
				text-transform: uppercase;
				position: relative;
				overflow: hidden;
				transition: 0.3s;
			}

			.more {
				background-color: #0acf97;
			}

			.more:after {
				left: 0;
			}

			button:hover:after {
				width: 100%;
				left: 0;
			}

			button:after {
				position: absolute;
				transition: 0.3s;
				content: '';
				width: 0;
				left: 50%;
				bottom: 0;
				height: 3px;
				background: #5180cc;
			}

			.delete {
				background: #e9ecef;
				color: #333333;
			}

			.useres {
				color: #00ac43;
			}

			.errors {
				color: #f00000;
			}
		}
	}
}
</style>
<template>
	<div>
		<titles titlename="设备管理" titlecontent="设备管理注释" :mbx="paths"></titles>
		<filters :rooms="filterslist"></filters>
		<div class="contentbox">
			<el-empty v-if="devicelist.length == 0" description="暂无实训设备"></el-empty>
			<ul>
				<li v-for="(item, index) in devicelist" :key="index" class="col-xs-12 col-sm-5 col-md-5 col-lg-3">
					<div @click="goxq(item, nowname)">
						<!-- style="width: 100%;height: 100%;" -->
						<img v-if="item.te_image" :src="item.te_image" alt="这是后台给的" srcset="" />
						<img v-else src="../../images/traindefut.jpg" alt="这是默认的" />
					</div>
					<p class="titimes">{{ item.te_deviceName }}</p>
					<div class="contenbz">
						<p style="color: red;font-weight: 600;">所属学院：{{ item.si_name }}</p>
						<p>所属实训室： {{ item.sx_tr_name }}</p>
						<p v-if="item.te_deviceState == 1" class="useres">状态：正常使用</p>
						<p v-if="item.te_deviceState == 0" class="useres" style="color: #F20000;">状态： 离线</p>
						<p v-if="item.te_deviceState == -1" class="useres" style="color: #f10000;">状态： 维护</p>
						<p v-if="item.te_deviceState == -2" class="useres">状态： 空闲</p>
					</div>

					<button v-if="item.islooking == 1" class="more" @click="goxq(item, nowname)">查看更多</button>
					<button v-if="item.isdelects == 1" class="delete" @click="deletecnow(item)">删除设备</button>
				</li>
			</ul>
		</div>

		<div class="elpagian">
			<el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :page-size="pagesize" :total="pageNumber"></el-pagination>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import filters from '@/components/filters/filterssb.vue';
import padination from '@/components/padination/padination.vue';
import { getPageTrainEquipmentList, GetTrainEquipmentDeletesb, getbfyGetTrainList } from '@/request/api/trainroom/trainroom.js';
import { GetbjGetSchoolList } from '@/request/api/mange/mange.js';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			// 筛选学校实训室设备
			schoollist: [],
			classlist: [],
			trinasbobj: {},
			searchs: '',
			siguid: '',
			sxxtrguid: '',
			// 设备列表
			nowname: '实训设备',
			devicelist: [],
			// 判断状态
			changes: 1,
			// 分页器
			pageNumber: 10,
			pagesize: 10,
			paganum: 1,
			// 判断使用状态
			changezt: 1,

			// 标题组件
			paths: [
				{
					path: '/allmanage',
					name: '实训管理'
				},
				{
					path: '/allmanage/trainingmange',
					name: '设备管理'
				}
			],

			// 筛选组件
			filterslist: {
				name: '实训设备',
				content: '',
				filterlist: [
					{
						id: 0,
						indexsshol: 0,
						title: '所属院校',
						childers: []
					},
					{
						id: 1,
						indexsshol: 0,
						title: '所属实训室',
						childers: []
					}
				]
			},
			powershowobj: {}
		};
	},

	beforeMount() {
		let allobj = {
			si_name_cn: '全部',
			shoolid: 0,
			si_guid: ''
		};
		GetbjGetSchoolList().then(res => {
			// console.log(res, "院校不分页")
			this.schoollist = JSON.parse(JSON.stringify(res.data.data));
			if (this.schoollist.length == 1) {
				allobj.si_guid = this.schoollist[0].si_guid;
				this.getclasslist(this.schoollist[0].si_guid);
				this.siguid = this.schoollist[0].si_guid;
				this.getrainsbeimg();
			} else {
				this.getclasslist();
				this.getrainsbeimg();
				this.schoollist.unshift(allobj);
			}
			this.schoollist.forEach(item => {
				item.name = item.si_name_cn;
			});
			this.filterslist.filterlist[0].childers = this.schoollist;
		});
	},
	mounted() {},
	created() {
		AppOptions.appEmpty = false;
	},
	methods: {
		// 更改学校
		changescholl(id) {
			this.siguid = id;

			this.getrainsbeimg();
		},
		// 更改实训室
		changetrin(id) {
			this.sxxtrguid = id;

			this.getrainsbeimg();
		},
		// 搜索实训室
		changesearch(searchs) {
			// console.log(searchs, "搜索")
			this.searchs = searchs;

			this.getrainsbeimg();
		},
		getclasslist(siguid = '') {
			getbfyGetTrainList(siguid).then(res => {
				// console.log(res, "实训室不分页")
				let classlist = [];
				classlist = JSON.parse(JSON.stringify(res.data.data));
				classlist.forEach(item => {
					item.name = item.tr_name;
				});
				let allobj = {
					name: '全部',
					shoolid: 0,
					sx_tr_guid: ''
				};

				classlist.unshift(allobj);
				this.classlist = classlist;
				this.filterslist.filterlist[1].childers = this.classlist;
			});
		},
		handleCurrentChange(val) {
			this.paganum = val;
			this.getrainsbeimg();
		},
		// 实训设备
		getrainsbeimg() {
			let trainsbeimgobj = {
				pageIndex: this.paganum,
				pageSize: this.pagesize,
				te_deviceName: this.searchs,
				sx_tr_guid: this.sxxtrguid,
				si_guid: this.siguid
			};
			getPageTrainEquipmentList(trainsbeimgobj).then(res => {
				// console.log(res)
				this.devicelist = res.data.data.list;

				this.pageNumber = res.data.data.totalCount;

				let powerlist = JSON.parse(window.sessionStorage.getItem('allbtnlist'));
				if (!powerlist) {
					powerlist = window.sessionStorage.getItem('allbtnlist');
				}
				this.powershowobj.powershows = powerlist;
				this.powershowobj.routers = this.$route.path;

				this.devicelist.forEach(item => {
					item.islooking = 0;
					item.isdelects = 0;
				});

				this.powershowobj.powershows.forEach(item => {
					if (item.path == this.$route.path && item.title == '查看设备') {
						this.devicelist.forEach(ite => {
							ite.islooking = 1;
						});
					} else if (item.path == this.$route.path && item.title == '删除设备') {
						this.devicelist.forEach(ite => {
							ite.isdelects = 1;
						});
					}
				});
			});
		},

		goxq(item, name) {
			this.powershowobj.powershows.forEach(items => {
				if (items.path == this.$route.path && items.title == '查看设备') {
					this.$router.push({
						path: '/device/roomxq?id=2&name=' + name + '&sx_te_guid=' + item.sx_te_guid
					});
				} else {
					console.log('没权限');
				}
			});
		},
		deletecnow(i) {
			console.log(i);
			this.trinasbobj = i;
			this.$confirm('确定删除这条记录吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let TrainDelete = {
						sx_te_guid: this.trinasbobj.sx_te_guid,
						isdelete: false
					};

					GetTrainEquipmentDeletesb(TrainDelete).then(res => {
						if (res.data.code == 1) {
							this.$message({
								message: '恭喜你，' + res.data.msg,
								type: 'success'
							});
							this.getrainsbeimg();
						} else {
							// let str = res.data.msg
							// let reg = /[#]/g;
							// str = str.replace(reg, ' <br/> ');
							// console.log(str);
							this.$confirm(res.data.msg + `<div style='color:red;'>当前记录删除后会删除关联数据且不能恢复，请谨慎选择</div>`, '提示', {
								confirmButtonText: '点击确定',
								cancelButtonText: '取消',
								type: 'warning',
								customClass: 'confirm',
								dangerouslyUseHTMLString: true
							})
								.then(() => {
									let TrainDeletes = {
										sx_te_guid: this.trinasbobj.sx_te_guid,
										isdelete: true
									};

									GetTrainEquipmentDeletesb(TrainDeletes).then(res => {
										if (res.data.code == 1) {
											this.$message({
												message: '恭喜你，' + res.data.msg,
												type: 'success'
											});
											this.getrainsbeimg();
										} else {
										}
									});
								})
								.catch(() => {
									// console.log("有记录删除")
								});
						}
					});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		}
	},
	components: {
		titles,
		filters,
		padination
	}
};
</script>

<style></style>
